import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { remove } from "sr/utils/axios";

type DeleteJobTypeParams =
  | { id: string }
  | { ids: string | string[] };

const buildDeleteJobTypeQuery = (params: DeleteJobTypeParams): string => {
  const queryParams = new URLSearchParams();

  if ("id" in params) {
    queryParams.append("id", params.id);
  }

  if ("ids" in params) {
    const ids = Array.isArray(params.ids)
      ? params.ids.filter(Boolean).join(",")
      : params.ids;

    if (ids) {
      queryParams.append("ids", ids);
    }
  }

  return queryParams.toString();
};

export const deleteJobType = async (
  params: DeleteJobTypeParams
): Promise<ApiResponse<[]> | null> => {
  try {
    const queryParams = buildDeleteJobTypeQuery(params);

    return await remove<ApiResponse<[]>>(`/cleaner/jobtype?${queryParams}`).then((res) => {
      if (res?.success === true) {
        return res;
      } else {
        return null;
      }
    });
  } catch (e) {
    HandleApiError(e);
    return null;
  }
};
